import React, { useEffect, useState, useReducer } from 'react';
import { useAuth } from '../../Context';

import { Empty, Row, Col, Typography, Button, Space, Table, Form, Input, Modal, Spin, Tooltip, message, Popover, Avatar, Card } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { PlusOutlined, DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';

import { INTERROGATOR_LIST, INTERROGATOR_LIST_SUCCESS, INTERROGATOR_LIST_ERROR } from './constants';
import { INTERROGATOR_DETAILS, INTERROGATOR_DETAILS_SUCCESS, INTERROGATOR_DETAILS_ERROR } from './constants';
import { ADD_INTERROGATOR_DETAILS, ADD_INTERROGATOR_DETAILS_SUCCESS, ADD_INTERROGATOR_DETAILS_ERROR } from './constants';
import { UPDATE_INTERROGATOR, UPDATE_INTERROGATOR_SUCCESS, UPDATE_INTERROGATOR_ERROR } from './constants';
import { DELETE_INTERROGATOR, DELETE_INTERROGATOR_SUCCESS, DELETE_INTERROGATOR_ERROR } from './constants';

import interrogatorReducer from './reducer';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';

import { useFormik } from 'formik';
import axios from 'axios';
import { ToolOutlined, InfoOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

export default function Interrogators() {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = {interrogators : [], details: null, pending: false, error: false };
	const [data, dispatch] = useReducer(interrogatorReducer, initalState);
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const [showAddInterrogatorModal, setShowAddInterrogatorModal] = useState(false);
	const [showEditInterrogatorModal, setShowEditInterrogatorModal] = useState(false);
	const [showDeleteInterrogatorModal, setShowDeleteInterrogatorModal] = useState(false);
	useAuth();
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const navigate = useNavigate();

	const columns = [
		{
			title: langdata && langdata.Manufacturer ? langdata.Manufacturer : 'Manufacturer',
			dataIndex: 'manufacturer',
			key: 'manufacturer',
			render: (text) => <span onClick={openEditInterrogatorModal}>{text}</span>,
		},
		{
			title: langdata && langdata.Model ? langdata.Model : 'Model',
			dataIndex: 'model',
			key: 'model',
		},
		{
			title: langdata && langdata.Version ? langdata.Version : 'Version',
			dataIndex: 'version',
			key: 'version',
		},
		{
			title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
			key: 'action',
			render: () => (
				permission === 'superadmin' || permission === 'admin' ? (
					<Space size="middle">
						<a title={langdata && langdata.EditInterrogator ? langdata.EditInterrogator : 'Edit Interrogator'} onClick={openEditInterrogatorModal}><EditOutlined/></a>
						<a title={langdata && langdata.DeleteInterrogator ? langdata.DeleteInterrogator :'Delete Interrogator'} onClick={openDeleteInterrogatorModal}><DeleteOutlined /></a>
					</Space>
				) : (
					<Space size="middle">
						<a title={langdata && langdata.EditInterrogator ? langdata.EditInterrogator : 'Edit Interrogator'} onClick={openEditInterrogatorModal}><EyeOutlined/></a>
					</Space>
				)
			)
		}
	];

	const openAddInterrogatorModal = () => {
		setShowAddInterrogatorModal(true);
	};

	const cloaseAddInterrogatorModal = () => {
		setShowAddInterrogatorModal(false);
	};

	const openEditInterrogatorModal = () => {
		setShowEditInterrogatorModal(true);
	};

	const closeEditInterrogatorModal = () => {
		setShowEditInterrogatorModal(false);
	};

	const openDeleteInterrogatorModal = () => {
		setShowDeleteInterrogatorModal(true);
	};

	const deleteInterrogator = () => {
		const id = parseInt(data.details.id);
    
		dispatch({ type: DELETE_INTERROGATOR });

		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/interrogators/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};

		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_INTERROGATOR_SUCCESS, payload: response});
					setShowDeleteInterrogatorModal(false);   
					loadInterrogator();       
				} else {
					dispatch({type:DELETE_INTERROGATOR_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_INTERROGATOR_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const closeDeleteInterrogatorModal = () => {
		setShowDeleteInterrogatorModal(false);
	};

	useEffect(() => {
		if(featuresModule.interrogatorEnabled == false) {
			navigate('/dashboard');
		}
		
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 1138);
	}, []);

	useEffect(() => {
		dispatch( { type: INTERROGATOR_LIST });
      
		loadInterrogator();
	}, []);

	const loadInterrogator = () => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/interrogators`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
  
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type:INTERROGATOR_LIST_SUCCESS, payload: response.data.data});
				}
			})
			.catch((error) => {
				dispatch({type:INTERROGATOR_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const loadInterrogatorDetails = ((id) => {
		let details = null;

		if (data && data.interrogators) {
			data.interrogators && data.interrogators.map((item) => {
				if (item.id === id) {
					details = item;
				}

				return true;
			});
      
			dispatch( { type: INTERROGATOR_DETAILS });
    
			if (!details) {
				dispatch({ type: INTERROGATOR_DETAILS_ERROR });
			} else {
				dispatch({ type: INTERROGATOR_DETAILS_SUCCESS, payload: details });

			}
		} else {
			dispatch({ type: INTERROGATOR_DETAILS_ERROR }); 
		}
	});

	const addInterrogatorFormik = useFormik({
		initialValues: {
			addManufacturerName: '',
			addModelLimit: '',
			addVersionLimit: 0
		},
		onSubmit: (values) => {
			const manufacturer = values.addManufacturerName ? values.addManufacturerName : '';
			const model = values.addModelLimit ? values.addModelLimit : '';
			const version = values.addVersionLimit ? values.addVersionLimit : 0;

			if (!manufacturer || manufacturer == null || manufacturer === '') {
				Modal.warning({ title: langdata && langdata.PleaseprovideavalidManufacturername ? langdata.PleaseprovideavalidManufacturername : 'Please provide a valid Manufacturer Name.' });
				return false;
			}
			if (!model || model == null || model === '') {
				Modal.warning({ title: langdata && langdata.PleaseprovideavalidModelname ? langdata.PleaseprovideavalidModelname : 'Please provide a valid Model Name.' });
				return false;
			}
			if (!version || version == null || version === '') {
				Modal.warning({ title: langdata && langdata.PleaseprovideavalidVersionNumber ? langdata.PleaseprovideavalidVersionNumber : 'Please provide a valid Version Number.' });
				return false;
			}

			// if(upperspeedLimit < lowerspeedLimit){
			// 	Modal.warning({ title: langdata && langdata.Upperlimitmustbegreaterthanlowerlimit ? langdata.Upperlimitmustbegreaterthanlowerlimit : 'Upper limit must be greater than lower limit' });
			// 	return false;
			// }

			// if((upperspeedLimit <= 0 || lowerspeedLimit <= 0)){
			// 	Modal.warning({ title: langdata && langdata.Upperorlowerlimitcannotbelessthanzero ? langdata.Upperorlowerlimitcannotbelessthanzero : 'Upper or lower limit cannot be less than zero' });
			// 	return false;
			// }

			// if((upperspeedLimit >= 450 || lowerspeedLimit >= 450)){
			// 	Modal.warning({ title: langdata && langdata.Upperorlowerlimitcannotbegreaterthan450 ? langdata.Upperorlowerlimitcannotbegreaterthan450 : 'Upper or lower limit cannot be greater than 450' });
			// 	return false;
			// }

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/interrogators`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					manufacturer: manufacturer,
					model: model,
					version: version
				}
			};

			dispatch( { type: ADD_INTERROGATOR_DETAILS });
      
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: ADD_INTERROGATOR_DETAILS_SUCCESS, payload: response});
						Modal.success({ title: langdata && langdata.InterrogatorAddedsuccessfully ? langdata.InterrogatorAddedsuccessfully : 'Interrogator Added Successfully.' });
						setShowAddInterrogatorModal(false);
						loadInterrogator();
					} else {
						dispatch({type: ADD_INTERROGATOR_DETAILS_ERROR});
						Modal.warning({ title: langdata && langdata.UnabletoAddtheinterrogator ? langdata.UnabletoAddtheinterrogator : 'Unable to Add the interrogator.' });  
					}
				})
				.catch((error) => {
					dispatch({type: ADD_INTERROGATOR_DETAILS_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	});

	const updateInterrogatorFormik = useFormik({
		enableReinitialize: true,
		initialValues: {
			updateManufacturerName: data.details ? data.details.manufacturer : '',
			updateModelLimit: data.details ? data.details.model : '',
			updateVersionLimit: data.details ? data.details.version : 0
		},
		onSubmit: (values) => {

			const id = data.details.id;
			const manufacturer = values.updateManufacturerName ? values.updateManufacturerName : '';
			const model = values.updateModelLimit ? values.updateModelLimit : '';
			const version = values.updateVersionLimit ? values.updateVersionLimit : 0;

			if (!manufacturer || manufacturer == null || manufacturer === '') {
				Modal.warning({ title: langdata && langdata.PleaseprovideavalidManufacturername ? langdata.PleaseprovideavalidManufacturername : 'Please provide a valid Manufacturer Name.' });
				return false;
			}
			if (!model || model == null || model === '') {
				Modal.warning({ title: langdata && langdata.PleaseprovideavalidModelname ? langdata.PleaseprovideavalidModelname : 'Please provide a valid Model name.' });
				return false;
			}
			if (!version || version == null || version === '') {
				Modal.warning({ title: langdata && langdata.PleaseprovideavalidVersionNumber ? langdata.PleaseprovideavalidVersionNumber : 'Please provide a valid Version number.' });
				return false;
			}

			// if(upperspeedLimit < lowerspeedLimit){
			// 	Modal.warning({ title: langdata && langdata.Upperlimitmustbegreaterthanlowerlimit ? langdata.Upperlimitmustbegreaterthanlowerlimit : 'Upper limit must be greater than lower limit' });
			// 	return false;
			// }

			// if((upperspeedLimit <= 0 || lowerspeedLimit <= 0)){
			// 	Modal.warning({ title: langdata && langdata.Upperorlowerlimitcannotbelessthanzero ? langdata.Upperorlowerlimitcannotbelessthanzero : 'Upper or lower limit cannot be less than zero' });
			// 	return false;
			// }

			// if((upperspeedLimit >= 450 || lowerspeedLimit >= 450)){
			// 	Modal.warning({ title: langdata && langdata.Upperorlowerlimitcannotbegreaterthan450 ? langdata.Upperorlowerlimitcannotbegreaterthan450 : 'Upper or lower limit cannot be greater than 450' });
			// 	return false;
			// }

			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/interrogators/${id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					manufacturer: manufacturer,
					model: model,
					version: version
				}
			};

			dispatch( { type: UPDATE_INTERROGATOR });

			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: UPDATE_INTERROGATOR_SUCCESS, payload:response});
						Modal.success({ title: langdata && langdata.Interrogatorupdatedsuccessfully ? langdata.Interrogatorupdatedsuccessfully : 'Interrogator updated successfully.' });
						setShowEditInterrogatorModal(false);
						loadInterrogator();
					} else {
						dispatch({type: UPDATE_INTERROGATOR_ERROR});
						Modal.warning({ title: langdata && langdata.Unabletoupdatetheinterrogator ? langdata.Unabletoupdatetheinterrogator : 'Unable to update the interrogator.' });  
					}
				})
				.catch((error) => {
					dispatch({type: UPDATE_INTERROGATOR_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	});

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{ langdata && langdata.InterrogatorContent1 ? langdata.InterrogatorContent1 :  'The Interrogators display and manage of various speed ranges for different types of vehicles. This classification helps in categorizing inspections conducted by Linewalker/NPV based on the vehicle&apos;s speed in the Security Tracking System (STS) application.'}</p>
		</Card>
	);

	return (
		permission==='superadmin' || permission === 'admin' ? 

			<>
				<Content>
					<Row style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center',
					}}
					>

						<Col span={12}>
							<Row>
								<Space>
									<ToolOutlined style={{fontSize:'30px'}}/>
									{/* </Col> */}
								</Space>
								<Space>&nbsp;&nbsp;</Space>
								<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.Interrogators ? langdata.Interrogators : 'Interrogators' }</Title>
							</Row>
						</Col>
					
						<Col span={12}>
							<Row justify="end">
								<Col>
									<Tooltip placement="bottom" title={langdata && langdata.Add ? langdata.Add : 'Add'}>
										<Space>
											{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={openAddInterrogatorModal} style={{margin:'5px'}} ><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New' }</Button> : null }
										</Space>
									</Tooltip>
									<Space>&nbsp;&nbsp;</Space>
									<Space>
										<Typography>
											<Popover title={langdata && langdata.Interrogators ? langdata.Interrogators : 'Interrogators' }  content={infoContent} trigger="click">
												<Avatar size="small"><InfoOutlined /></Avatar>
											</Popover>
										</Typography>
									</Space>
								</Col>
							</Row>
						</Col>
					</Row>
					<Row span={24} style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={24}>
							{ data && data.interrogators.length > 0 ? (
								<Table
									scroll={{
										x: 900,
									}} 
									columns={columns} 
									dataSource={data && data.interrogators} 
									onRow = {(record) => {
										return {
											onClick: () => { 
												loadInterrogatorDetails(record.id);
											}
										};
									}} />
							)
								:
								(
									<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
								)}
						</Col>
					</Row>
				</Content>

				<Spin fullscreen spinning={data.pending} />
      
				{/* Add Interrogator Starts */}
				<Modal
					title={langdata && langdata.AddInterrogator ? langdata.AddInterrogator : 'Add Interrogator' }
					centered
					destroyOnClose={true}
					maskClosable={false}
					open={showAddInterrogatorModal}
					onOk={{cloaseAddInterrogatorModal}}
					onCancel={cloaseAddInterrogatorModal}
					footer={[
					// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={cloaseAddInterrogatorModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
							{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={addInterrogatorFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
						</Space>
					]}
					width={800}
				>
					<Form layout="vertical" onSubmit={addInterrogatorFormik.handleSubmit}>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="manufacturer" label={langdata && langdata.Manufacturer ? langdata.Manufacturer : 'Manufacturer'} rules={[{ required: true, message: langdata && langdata.PleaseenterManufacturer ? langdata.PleaseenterManufacturer : 'Please enter Manufacturer name' }]} >
									<Input name="addManufacturerName" onChange={addInterrogatorFormik.handleChange} placeholder={langdata && langdata.PleaseenterManufacturer ? langdata.PleaseenterManufacturer : 'Please enter Manufacturer name'} />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="model" label={langdata && langdata.Model ? langdata.Model : 'Model'} rules={[{ required: true, message: langdata && langdata.PleaseentertheModelName ? langdata.PleaseentertheModelName : 'Please enter the Model Name' }]} >
									<Input name="addModelLimit" onChange={addInterrogatorFormik.handleChange} placeholder={langdata && langdata.PleaseentertheModelName ? langdata.PleaseentertheModelName : 'Please enter the Model Name'} />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="version" label={langdata && langdata.Version ? langdata.Version : 'Version'} rules={[{ required: true, message: langdata && langdata.PleaseentertheVersion ? langdata.PleaseentertheVersion : 'Please enter the Version' }]} >
									<Input name="addVersionLimit" onChange={addInterrogatorFormik.handleChange} placeholder={langdata && langdata.PleaseentertheVersion ? langdata.PleaseentertheVersion : 'Please enter the Version'} />
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>
				{/* Add Interrogator Ends */}

				{/* Edit Interrogator Starts */}
				<Modal
				
					title={langdata && langdata.EditInterrogator ? langdata.EditInterrogator : 'Edit Interrogator'}
					centered
					open={showEditInterrogatorModal}
					onOk={{closeEditInterrogatorModal}}
					onCancel={closeEditInterrogatorModal}
					footer={[
					// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={closeEditInterrogatorModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
							{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={updateInterrogatorFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
						</Space>
					]}
					width={800}
				>
					<Form layout="vertical" onSubmit={updateInterrogatorFormik.handleSubmit}>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.Manufacturer ? langdata.Manufacturer : 'Manufacturer'} rules={[{ required: true, message: langdata && langdata.PleaseenterManufacturer ? langdata.PleaseenterManufacturer : 'Please enter Manufacturer name' }]} required>
									<Input name="updateManufacturerName" onChange={updateInterrogatorFormik.handleChange} placeholder={langdata && langdata.PleaseenterManufacturer ? langdata.PleaseenterManufacturer : 'Please enter Manufacturer name'} value={updateInterrogatorFormik.values.updateManufacturerName} />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.Model ? langdata.Model : 'Model'} rules={[{ required: true, message: langdata && langdata.PleaseentertheModelName ? langdata.PleaseentertheModelName : 'Please enter the lower limit' }]} required>
									<Input name="updateModelLimit"  onChange={updateInterrogatorFormik.handleChange}  placeholder={langdata && langdata.PleaseentertheModelName ? langdata.PleaseentertheModelName : 'Please enter the Model Name'} value={updateInterrogatorFormik.values.updateModelLimit} />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.Version ? langdata.Version : 'Version'} rules={[{ required: true, message: langdata && langdata.PleaseentertheVersion ? langdata.PleaseentertheVersion : 'Please enter the upper limit' }]} required>
									<Input name="updateVersionLimit"  onChange={updateInterrogatorFormik.handleChange} placeholder={langdata && langdata.PleaseentertheVersion ? langdata.PleaseentertheVersion : 'Please enter the Version'} value={updateInterrogatorFormik.values.updateVersionLimit} />
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>
				{/* Edit Interrogator Ends */}

				{/* Delete Interrogator Starts */}
				<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteInterrogatorModal} onOk={deleteInterrogator} onCancel={closeDeleteInterrogatorModal}>
					<Row style={{
						marginTop: '10px',
						marginBottom: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={1}>
							<DeleteOutlined  style={{ fontSize: '14px'}}/>
						</Col>
						<Col span={23}> {langdata && langdata.Areyousureyouwanttodeletethisinterrogator ? langdata.Areyousureyouwanttodeletethisinterrogator : 'Are you sure you want to delete this interrogator?' }</Col>
					</Row>
				</Modal>
				{/* Delete Interrogator Ends */}
			</> : null
	);
}